<div class="wishlist-container d-flex flex-column">
  <div class="d-flex justify-content-between align-items-center">
    <span class="wishlist-text">Confirm Member Name</span>
    <div class="img-container" mat-dialog-close>
      <img
        src="../../../assets/images/crossIconDarkTheme.svg"
        class="cross-icon"
      />
    </div>
  </div>

  <div class="d-flex flex-column mt-5">
    <label class="select-wishlist mb-1"
      >Member Name and Philanthropy name do not match</label
    >
  </div>
  <div class="d-flex justify-content-center mt-5">
    <button
      class="dp-primary-btn wishlist-btn ms-3"
      (click)="onContinueClick()"
    >
      Yes, Continue
    </button>
    <button class="dp-secondary-btn wishlist-btn ms-3" mat-dialog-close>
      No, cancel
    </button>
  </div>
</div>
